import { render, staticRenderFns } from "./CommodityMgmtV2.vue?vue&type=template&id=279e21f8"
import script from "./CommodityMgmtV2.vue?vue&type=script&lang=js"
export * from "./CommodityMgmtV2.vue?vue&type=script&lang=js"
import style0 from "./CommodityMgmtV2.vue?vue&type=style&index=0&id=279e21f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports